import React from 'react';

const NotFound = () => (
    <div className="container mt-5">
        <h2>Not Found!!!!</h2>
    </div>
);

export default NotFound;